import React from "react"
import styled, { css } from "styled-components"
import Breakpoints from "../breakpoints"
import { FontFamilyRegular } from "../typography.styles"
import Link from "../smart-link.js"
import Hamburger from "../svg/hamburger-icon"

import { T } from "../typography.styles"

export const Banner = styled.div`
  display: ${(props) => (props.visible ? `flex` : `none`)};
  justify-content: center;
  align-items: center;
  background-color: var(--burnt-orange);
  color: white;
  ${T.sm.body.regular};
  font-size: 14px;
  z-index: 900;
  padding: 2px 20px;
  p {
    text-align: center;
  }
  a {
    color: inherit;
  }

  @media (min-width: ${Breakpoints.lg}) {
    font-size: 16px;
  }
`

export const HeaderWrapper = styled.header`
  position: ${(props) => props.headerPosition ?? "fixed"};
  transform: ${(props) =>
    props.isHidden ? "translate3d(0, -101%, 0)" : "translate3d(0)"};
  /* padding: 24px 40px; */
  /*margin-top: ${(props) => props.marginTop}px;*/

  z-index: 900;
  width: 100%;
  box-sizing: border-box;
  transition: transform 0.25s ease-in, background-color 0.25s ease-in;
  background-color: ${(props) =>
    props.showBackground ? "var(--tricorn-black)" : "none"};

  @media (min-width: ${Breakpoints.lgPlus}) {
    position: ${(props) =>
      props.headerPosition ? props.headerPosition : "absolute"};
    margin-top: 0;
  }
`

export const Navigation = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1440px;
  flex-grow: 1;
  justify-self: center;
  padding: 24px 40px;
`

export const HeaderInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const RightButtons = styled.nav`
  display: none;

  @media (min-width: ${Breakpoints.lgPlus}) {
    display: flex;
  }

  align-items: stretch;
  justify-content: flex-end;
  position: relative;

  & > * {
    margin: 0 0 0 32px;
    white-space: nowrap;
    ${FontFamilyRegular}
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    background-color: transparent;
  }

  & > *:nth-last-child(2) {
    margin: 0 0 0 48px;
  }

  & > *:nth-last-child(1) {
    margin: 0 0 0 16px;
  }

  & > *:nth-last-child(1),
  & > *:nth-last-child(2) {
    border: 1px solid var(--white);
    padding: 16px 32px;
    text-decoration: none;
    cursor: pointer;
    color: #fff;
    :active,
    :visited,
    :link {
      color: #fff;
    }
  }
`

export const ImageContainer = styled(Link)`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  align-self: center;
  width: 125px;
  grid-column: 1 / 3;

  & > img {
    max-width: 125px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    margin-top: -11px;
  }
`
const HamburgerIconWrapper = styled.div`
  @media (min-width: ${Breakpoints.lgPlus}) {
    display: none;
  }
  cursor: pointer;
  background-color: none;
  pointer-events: all;
  height: 28px;
  grid-column: -1;
`

export const HamburgerIcon = (props) => {
  return (
    <HamburgerIconWrapper>
      <Hamburger {...props} />
    </HamburgerIconWrapper>
  )
}
